import React, { useEffect, useState, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
const BlockAAndBReport = React.lazy(() => import('./BlockAAndBReport'));
const BlockCReport = React.lazy(() => import('./BlockCReport'));
const BlockDReport = React.lazy(() => import('./BlockDReport'));
const BlockEReport = React.lazy(() => import('./BlockEReport'));
const BlockFReport = React.lazy(() => import('./BlockFReport'));
const BlockGReport = React.lazy(() => import('./BlockGReport'));
const BlockHReport = React.lazy(() => import('./BlockHReport'));
const BlockIReport = React.lazy(() => import('./BlockIReport'));
const BlockJReport = React.lazy(() => import('./BlockJReport'));
const BlockKAndLReport = React.lazy(() => import('./BlockKAndLReport'));
const BlockMAndNReport = React.lazy(() => import('./BlockMAndNReport'));

const AllBlocksReport = () => {
  const navigate = useNavigate();
  const searchParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams();
  const autoPrint = searchParams.get('autoPrint') === '1';
  const [showSections, setShowSections] = useState(autoPrint);
  const [visibleCount, setVisibleCount] = useState(autoPrint ? 1 : 0);

  const reportSections = [
    { key: 'A-B', label: 'Block A and B', Component: BlockAAndBReport },
    { key: 'C', label: 'Block C', Component: BlockCReport },
    { key: 'D', label: 'Block D', Component: BlockDReport },
    { key: 'E', label: 'Block E', Component: BlockEReport },
    { key: 'F', label: 'Block F', Component: BlockFReport },
    { key: 'G', label: 'Block G', Component: BlockGReport },
    { key: 'H', label: 'Block H', Component: BlockHReport },
    { key: 'I', label: 'Block I', Component: BlockIReport },
    { key: 'J', label: 'Block J', Component: BlockJReport },
    { key: 'K-L', label: 'Block K and L', Component: BlockKAndLReport },
    { key: 'M-N', label: 'Block M and N', Component: BlockMAndNReport }
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!showSections) return;
    if (visibleCount >= reportSections.length) return;

    const timer = setTimeout(() => {
      setVisibleCount((count) => Math.min(count + 1, reportSections.length));
    }, 300);

    return () => clearTimeout(timer);
  }, [showSections, visibleCount, reportSections.length]);

  useEffect(() => {
    if (!autoPrint || !showSections || visibleCount !== reportSections.length) return;

    const timer = setTimeout(() => {
      window.print();
    }, 500);

    return () => clearTimeout(timer);
  }, [autoPrint, showSections, visibleCount, reportSections.length]);

  const handleStartPreview = () => {
    setShowSections(true);
    setVisibleCount(1);
  };

  return (
    <>
      <div className="container-fluid py-3 no-print">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
          <div>
            <h4 className="mb-2">ASI Print Preview: Blocks A to N</h4>
            <p className="mb-0">Review all block reports together, then click Print to generate the full ASI return.</p>
          </div>
          <div className="mt-3 mt-md-0">
            <button
              type="button"
              className="btn btn_orange me-2"
              onClick={() => window.print()}
              disabled={!showSections || visibleCount < reportSections.length}
            >
              Print all Blocks A-N
            </button>
            <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>
              Back
            </button>
          </div>
        </div>
        <hr />
      </div>

      <div className="container-fluid print-preview-all-blocks">
        {!showSections ? (
          <div className="alert alert-info">
            <p className="mb-2">The full ASI preview is ready to load. This page opens quickly and then prepares the report sections progressively.</p>
            <button type="button" className="btn btn_orange" onClick={handleStartPreview}>
              Load Preview Sections
            </button>
          </div>
        ) : (
          <>
            <div className="mb-3">
              <strong>Loaded {visibleCount} of {reportSections.length} sections.</strong>
            </div>
            {reportSections.slice(0, visibleCount).map(({ key, label, Component }) => (
              <div key={key} className="block-print-section mb-4">
                <div className="mb-2">
                  <h5 className="mb-1">{label}</h5>
                </div>
                <Suspense fallback={<div className="alert alert-secondary">Loading {label} section...</div>}>
                  <Component />
                </Suspense>
              </div>
            ))}
            {visibleCount < reportSections.length && (
              <div className="alert alert-warning">
                <strong>Loading remaining sections...</strong> Please wait until all report blocks appear.
              </div>
            )}
          </>
        )}
      </div>

      <style>
        {`
          .no-print {
            display: block;
          }

          .block-print-section {
            page-break-after: always;
          }

          @media print {
            .no-print {
              display: none !important;
            }

            .block-print-section {
              page-break-after: always;
            }

            .container-fluid {
              padding-left: 0 !important;
              padding-right: 0 !important;
            }
          }
        `}
      </style>
    </>
  );
};

export default AllBlocksReport;
